import { StationDetailActions } from './../actions/stationDetails';
import { User } from '../../models/User';
import { Station } from '../../models/Station';
export interface StationDetailsState {
  station?: Station;
  qr: string;
  users: User[];
}

const initialState: StationDetailsState = {
  station: undefined,
  qr: '',
  users: [],
};

export default (state = initialState, action: StationDetailActions) => {
  switch (action.type) {
    case 'GET_STATION_DETAILS':
      const qrString = `${action.payload.station.id}:${action.payload.station.name}:${action.payload.station.address}:${action.payload.station.postcode}:${action.payload.station.state}`;
      return {
        ...state,
        station: action.payload.station,
        qr: qrString,
        users: action.payload.users,
      };
    case 'USERS_STATION':
      return {
        ...state,
        users: action.payload.users,
      };
    default:
      return state;
  }
};
